import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "multiple-choice w-[1200px] h-[100px] fixed"
}
const _hoisted_2 = { class: "bar flex items-center justify-between h-full px-[24px]" }
const _hoisted_3 = { class: "left flex items-center gap-[12px]" }
const _hoisted_4 = { class: "selected-tip" }
const _hoisted_5 = { class: "center action-group flex items-center gap-[12px]" }
const _hoisted_6 = { class: "right" }

import { ref, watch, computed } from 'vue'
import { ElButton, ElCheckbox, ElIcon, ElMessage, ElMessageBox } from 'element-plus'
import { CopyDocument, FolderOpened, Download, Delete } from '@element-plus/icons-vue'
import { multipleChoiceStore } from "@/stores/multipleChoice"
import { folderOperate } from "@/api/ResourceMasonry"
//@ts-ignore
import MoveDialog from '@/views/shared/components/MoveDialog.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'multipleChoice',
  props: {
    corpCode: { type: String, default: '' },
    activeFolder: { type: Object, default: () => ({}) }
},
  emits: ['refresh'],
  setup(__props, { emit: __emit }) {

const multipleChoice = multipleChoiceStore()
const props = __props
const selectedCount = computed(() => multipleChoice.selectedCount)
const multipleChoiceshow = computed(() => multipleChoice.multipleChoice)
const moveVisible = ref(false)
const moveAction = ref('move')


const emit = __emit
const onCopy = () => {
    moveAction.value = 'copy'
    moveVisible.value = true
}
const onMove = () => {
    moveAction.value = 'move'
    moveVisible.value = true
}
const onDownload = () => {

}
const onDelete = () => {
    ElMessageBox.confirm(`确认删除？删除后不可恢复`, '删除资源', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(async () => {
        let resource_ids = multipleChoice.selectedResources.join(',')
        let folder_ids = multipleChoice.selectFolder.join(',')
        await deleteResource(resource_ids)
        await deleteFolder(folder_ids)
        multipleChoice.clearSelected()
        emit('refresh')
        // try {
        //     await folderOperate({ kind: 'resource', action: 'delete', resource_id: item.id, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
        //     // resourceList.value = resourceList.value.filter(x => x.id !== item.id)
        //     // ElMessage.success('资源已删除')
        //     // detailVisible.value = false
        // } catch { }
    }).catch(() => { })
}
const onCancel = () => { multipleChoice.clearSelected(); }
const onMoveConfirm = async () => {
    moveVisible.value = false
    multipleChoice.clearSelected()
    emit('refresh')
}
const deleteFolder = async (ids) => {
    if (!ids) return
    try {
        await folderOperate({ kind: 'folder', action: 'delete', folder_id: ids, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
        return
    } catch {
        return
    }
}
const deleteResource = async (ids) => {
    if (!ids) return
    try {
        await folderOperate({ kind: 'resource', action: 'delete', resource_id: ids, owner_type: props.corpCode ? 'team' : 'user', corp_code: props.corpCode })
        return
    } catch {
        return
    }
}


return (_ctx: any,_cache: any) => {
  return (multipleChoiceshow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, "已选择 " + _toDisplayString(selectedCount.value) + " 个资源/文件夹", 1),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(ElButton), {
                class: "action-btn",
                plain: "",
                onClick: onCopy
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElIcon), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CopyDocument))
                    ]),
                    _: 1
                  }),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "ml-[6px]" }, "复制", -1))
                ]),
                _: 1
              }),
              _createVNode(_unref(ElButton), {
                class: "action-btn",
                plain: "",
                onClick: onMove
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElIcon), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FolderOpened))
                    ]),
                    _: 1
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "ml-[6px]" }, "移动", -1))
                ]),
                _: 1
              }),
              _createVNode(_unref(ElButton), {
                class: "action-btn",
                plain: "",
                type: "danger",
                onClick: onDelete
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(ElIcon), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Delete))
                    ]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "ml-[6px]" }, "删除", -1))
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(ElButton), {
              link: "",
              onClick: onCancel
            }, {
              default: _withCtx(() => [
                _createTextVNode("取消" + _toDisplayString(__props.activeFolder.id), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(MoveDialog, {
          modelValue: moveVisible.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((moveVisible).value = $event)),
          type: 'all',
          "corp-code": props.corpCode,
          current: { folder_id: __props.activeFolder.id || '' },
          multiple: true,
          action: moveAction.value,
          onConfirm: onMoveConfirm
        }, null, 8, ["modelValue", "corp-code", "current", "action"])
      ]))
    : _createCommentVNode("", true)
}
}

})